import { render, staticRenderFns } from "./IndividualExamQuestionOverviewPage.vue?vue&type=template&id=42a7f806&scoped=true"
import script from "./IndividualExamQuestionOverviewPage.vue?vue&type=script&lang=js"
export * from "./IndividualExamQuestionOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7f806",
  null
  
)

export default component.exports